import type { FeatureFlags } from "@veltro/shared/types";
import { useAuth } from "@/shared/auth/useAuth";

/**
 * Returns the current tenant's feature flags, or null if not loaded yet.
 */
export function useFeatureFlags(): FeatureFlags | null {
  const { tenant } = useAuth();
  return tenant?.featureFlags ?? null;
}

/**
 * Returns whether a specific feature flag is enabled.
 * Defaults to true while flags are loading (graceful degradation).
 */
export function useFeatureEnabled(flag: keyof FeatureFlags): boolean {
  const flags = useFeatureFlags();
  if (!flags) return true;
  return flags[flag];
}
